import { ApiQueryParams, apiRequest } from '../Api';

export type DeleteWebsiteModuleRequest = ApiQueryParams & {
  deletion_type: 'soft' | 'achive' | 'hard';
  cascade?: boolean;
};

export interface DeleteWebsiteModuleResponse {
  success: boolean;
  message: string;
  execution_time: number;
  cached: boolean;
  timestamp: string;
}

export const deleteWebsiteModule = (
  moduleId: string,
  params: DeleteWebsiteModuleRequest
) =>
  apiRequest<void, DeleteWebsiteModuleResponse>({
    url: `/entities/delete/${moduleId}`,
    scope: 'module',
    method: 'DELETE',
    params:
      params as unknown as ApiQueryParams &
        Record<string, string | number | boolean | undefined>,
  });
